export default __webpack_public_path__ + "85cd7e05187fdf469dc57872fc6d5982.svg";